import dcapital from './dcapital.uk';
export default {
  nav: { home: 'Головна', selection: 'Відбір трейдерів', training: 'Навчання', apply: 'Залишити заявку', signin: 'Увійти' },
  ticker: ['AAPL +1.24%', 'TSLA -0.87%', 'NVDA +2.41%', 'MSFT +0.66%', 'NASDAQ 18 412.55', 'NYSE 19 204.11', 'AMZN +1.02%', 'META -0.43%', 'GOOGL +0.95%', 'AMD +3.12%'],
  common: { result: 'Результат', popular: 'Популярний', soldOut: 'Розпродано', waitlistBtn: 'До листа очікування', soldOutHint: 'Місць немає. Залиште заявку, щоб потрапити до листа очікування.', choose: 'Обрати формат', start: 'Старт', orPaypal: 'або сплатіть через' },
  home: {
    heroOverline: 'Професійна торгова платформа · NYSE & NASDAQ',
    heroLines: ['Торгуй на', 'американському', 'ринку акцій'],
    heroSub: 'Проп-команда ALEF. Навчаємо трейдерів з нуля та відбираємо найкращих — пройди кваліфікацію один раз і отримуй капітал в управління до $1 000 000.',
    ctaPrimary: 'Пройти відбір',
    ctaSecondary: 'Програма навчання',
    stats: [
      { v: '$1M', l: 'Максимальний капітал', s: 'Зростає в міру стабільності' },
      { v: '12 тижнів', l: 'Програма навчання', s: 'Покроковий шлях NYSE & NASDAQ' },
      { v: '1×', l: 'Одна кваліфікація', s: 'Рахунок збільшується автоматично' },
    ],
    pillarsOverline: 'Три напрямки',
    pillarsTitle: 'Обери свій шлях у трейдингу',
    pillars: [
      { num: '01', title: 'Відбір трейдерів', desc: 'Вже торгуєш? Продемонструй стабільність на демо-етапі й отримай реальний рахунок з масштабуванням капіталу до $1M.', cta: 'Подати заявку на відбір' },
      { num: '02', title: 'Навчання з нуля', desc: 'Тримісячна програма: від будови ринку до власної торгової системи — з живими заняттями та супроводом наставника.', cta: 'Дивитися програму' },
      { num: '03', title: 'Карʼєра в команді', desc: 'Найкращі випускники та трейдери, що пройшли відбір, торгують капіталом компанії, ростуть у частці прибутку й стають наставниками.', cta: 'Розпочати шлях' },
    ],
    whyOverline: 'Ринок',
    whyTitle: 'Чому NYSE & NASDAQ?',
    whyItems: [
      'Найбільші та найліквідніші біржі світу',
      'Apple, Microsoft, Google, Tesla та тисячі інших компаній',
      'Капіталізація ринку — понад $50 трлн',
      'Торгові можливості щодня, 9:30–16:00 EST',
      'Професійні інструменти та дані в реальному часі',
    ],
    benOverline: 'Переваги',
    benTitle: 'Чому ALEF TRADERS',
    benefits: [
      { t: 'Капітал під результат', d: 'Доступ до серйозного торгового капіталу — залежно від твоєї стабільності та ризик-менеджменту.' },
      { t: 'Професійна підтримка', d: 'Виділена команда підтримки, просунуті інструменти та інфраструктура інституційного рівня.' },
      { t: 'Гнучкий розподіл прибутку', d: 'Конкурентна модель profit split, що винагороджує стабільність і дисципліну.' },
      { t: 'Карʼєрне зростання', d: 'Можливості розвитку, менторство та професійне зростання всередині команди.' },
    ],
    aboutOverline: 'Про компанію',
    aboutName: 'ALEF TRADERS',
    aboutRole: 'Професійна команда трейдерів · NYSE & NASDAQ',
    aboutBio: 'ALEF Traders — команда професійних трейдерів американського фондового ринку. Ми на ринку з 2012 року, а на професійній основі працюємо з 2017. За цей час команда керувала фондом понад $10 000 000 і заробила більше $3 000 000. Сьогодні ми розвиваємо власну проп-команду: навчаємо трейдерів з нуля та пропонуємо найкращим учням і кандидатам, які пройшли відбір, торгувати капіталом компанії.',
    aboutStats: [
      { v: '2012', l: 'На ринку з' },
      { v: '$10M+', l: 'Під управлінням' },
      { v: '$3M+', l: 'Прибуток команди' },
    ],
    ctaTitle: 'Готовий розпочати карʼєру трейдера?',
    ctaSub: 'Починаєш з нуля чи приходиш з досвідом — у нас є відповідний шлях для тебе.',
    ctaBtn: 'Залишити заявку',
  },
  selection: {
    overline: 'Для досвідчених трейдерів',
    heroLines: ['Покажи навичку.', 'Отримай капітал', 'до $1 000 000'],
    heroSub: 'Жодних співбесід і дипломів — лише твоя торгівля. Пройди відбір на демо-рахунку й торгуй капіталом компанії на NYSE & NASDAQ.',
    ctaBtn: 'Подати заявку на відбір',
    metrics: [
      { v: '$1M', l: 'Максимальний капітал' },
      { v: '30–50%', l: 'Частка прибутку' },
      { v: '2', l: 'Етапи відбору' },
      { v: '9:30–16:00', l: 'Сесія EST' },
    ],
    stepsOverline: 'Процес',
    stepsTitle: 'Як влаштований відбір',
    steps: [
      { num: '01', t: 'Заявка', d: 'Заповни коротку форму — розкажи про свій досвід і ринки, на яких торгуєш.' },
      { num: '02', t: 'Демо-етап', d: 'Торгуй на демо-рахунку за правилами ризик-менеджменту. Покажи стабільність і досягни цілі з прибутку.' },
      { num: '03', t: 'Верифікація', d: 'Підтвердь результат на другому етапі з мʼякшими цілями — ми перевіряємо системність, а не вдачу.' },
      { num: '04', t: 'Реальний рахунок', d: 'Отримай капітал в управління. За стабільну торгівлю рахунок масштабується — аж до $1 000 000.' },
    ],
    condOverline: 'Умови',
    condTitle: 'Правила гри',
    conditions: [
      'Ринки: акції NYSE & NASDAQ',
      'Денний ліміт збитку та загальний ліміт просідання',
      'Ціль з прибутку на кожному етапі без порушення ризиків',
      'Масштабування рахунку за стабільну торгівлю',
      'Регулярні виплати прибутку за розкладом',
    ],
    benOverline: 'Чому ми',
    benTitle: 'Що отримує трейдер команди',
    priceOverline: 'Вартість участі',
    priceTitle: 'Відбір трейдерів — два формати участі',
    plans: [
      {
        key: 'online', name: 'Онлайн', price: '$999', note: 'Одноразовий платіж: міні-курс + участь у відборі',
        features: ['Міні-курс із трейдингу — доступ онлайн у записі', 'Доступ до демо-етапу відбору', 'Перевірка результатів і зворотний звʼязок від команди', 'У разі успіху — реальний рахунок із капіталом компанії', 'Масштабування капіталу до $1 000 000'],
        fit: 'Проходьте відбір з будь-якої точки світу у зручному ритмі.',
      },
      {
        key: 'office', name: 'В офісі', price: '$1 499', note: 'Одноразовий платіж: усе з онлайн-формату + робота в офісі', badge: true,
        features: ['Усе з онлайн-формату', 'Обладнане робоче місце в офісі на весь період відбору', 'Торгівля поруч із командою в реальному часі', 'Живі розбори угод і щоденний контакт із наставниками', 'Занурення в робоче середовище професійних трейдерів', 'Пріоритетний розгляд результатів'],
        fit: 'Для тих, хто хоче якнайшвидше влитися в команду і торгувати пліч-о-пліч із професіоналами.',
      },
    ],
    priceBtn: 'Сплатити та пройти відбір',
    payMethods: 'Оплата карткою (Stripe), PayPal або USDT (TRC20) — одразу після короткої заявки',
    ctaTitle: 'Готовий пройти відбір?',
    ctaSub: 'Залиш заявку — команда звʼяжеться з тобою в Telegram протягом робочого дня.',
  },
  training: {
    badge: 'Старт потоку · 18 січня 2027 · набір відкрито',
    heroLines: ['Професійне', 'навчання', 'трейдингу'],
    heroSub: 'Від перших кроків на ринку до самостійної торгівлі під супроводом наставника.',
    ctaPrimary: 'Записатися на консультацію',
    ctaSecondary: 'Переглянути формати',
    countdownTitle: 'До старту потоку:',
    countdownUnits: { d: 'днів', h: 'годин', m: 'хвилин', s: 'секунд' },
    stats: [
      { v: '3 міс.', l: 'Тривалість' },
      { v: 'Live', l: 'Онлайн-заняття' },
      { v: 'Реальний', l: 'Ринок' },
      { v: 'Mentor', l: 'Супровід' },
    ],
    approachOverline: 'Наш підхід',
    approachQuote: '«Ми навчаємо професії трейдера, а не продаємо мрію про швидке збагачення.»',
    approachText1: 'Більшість курсів обмежуються набором відеоуроків «у записі» — теорія без зворотного звʼязку, без контролю та без супроводу.',
    approachText2: 'Наша програма влаштована інакше. Учень проходить повний шлях: новачок → практика → власна торгова система → реальна торгівля.',
    compOverline: 'Що входить до програми',
    compTitle: 'Шість компонентів, які роблять результат передбачуваним',
    components: [
      { t: 'Теорія', d: 'Фундаментальні знання про ринок, інструменти та стратегії.' },
      { t: 'Практика', d: 'Реальні графіки, розбір угод, відпрацювання навичок.' },
      { t: 'Зворотний звʼязок', d: 'Індивідуальний розбір ваших помилок і рішень.' },
      { t: 'Наставництво', d: 'Прямий контакт із чинним трейдером.' },
      { t: 'Спільнота', d: 'Закритий чат із менторами та випускниками.' },
      { t: 'Супровід', d: 'Підтримка під час переходу на реальний рахунок.' },
    ],
    princOverline: 'Чому програма працює',
    princTitle: 'Вісім принципів, що відрізняють нас від записаних курсів',
    principles: [
      'Живі заняття в режимі реального часу',
      'Можливість ставити запитання під час навчання',
      'Записи всіх занять — доступ назавжди',
      'Закрита спільнота практикуючих трейдерів',
      'Розбір реальних ринкових ситуацій',
      'Індивідуальний зворотний звʼязок по угодах',
      'Підготовка власної торгової системи',
      'Супровід до виходу на реальний ринок',
    ],
    roadOverline: 'Дорожня карта',
    roadTitle: 'Місяць 1 → Місяць 2 → Місяць 3',
    roadSub: 'Фундамент → Практика → Реальна торгівля',
    months: [
      {
        num: '01', meta: '4 тижні · 3 заняття на тиждень · 1–1,5 години', title: 'Фундамент трейдера',
        items: ['Знайомство з фінансовими ринками', 'Будова трейдингу', 'Відкриття торгового рахунку', 'Налаштування термінала', 'Робота з ордерами', 'Технічний аналіз', 'Тренди та рівні', 'Пробої та розвороти', 'Торгові стратегії', 'Ризик-менеджмент', 'Психологія трейдингу'],
        result: 'Учень розуміє ринок і вміє самостійно аналізувати графіки.',
      },
      {
        num: '02', meta: '4 тижні · 2 розбори на тиждень + індивідуальна робота · до 2 годин', title: 'Практика та власна торгова система',
        items: ['Практичні заняття в ефірі', 'Розбір ринку в реальному часі', 'Розбір угод учасників', 'Аналіз помилок', 'Додаткова теорія', 'Індивідуальний зворотний звʼязок', 'Формування власної системи', 'Створення торгового плану'],
        result: 'Учень отримує робочу систему прийняття рішень і готується до самостійної торгівлі.',
      },
      {
        num: '03', meta: '4 тижні · супровід наставника, дзвінки 2 рази на тиждень · 1–1,5 години', title: 'Вихід на реальну торгівлю',
        items: ['Підготовка до реальної торгівлі', 'Контроль дотримання ризик-менеджменту', 'Розбір реальних угод', 'Супровід наставника', 'Допомога в психологічній адаптації'],
        result: 'Учень починає торгувати самостійно під контролем наставника.',
      },
    ],
    formatOverline: 'Формат навчання',
    formatTitle: 'Живе навчання + архів записів',
    formatItems: [
      'Усі заняття проходять онлайн через Zoom / Google Meet',
      'Тривалість занять — 1–1,5 години, розбори угод до 2 годин',
      'Прямий ефір — запитання під час заняття',
      'Кожне заняття записується',
      'Доступ до архіву зберігається на весь термін навчання',
      'Можливість передивлятися матеріал будь-коли',
    ],
    commOverline: 'Закрита спільнота',
    commTitle: 'Чат, де торгують, а не «мотивують»',
    commItems: ['Наставники та практикуючі трейдери', 'Учні поточного потоку', 'Випускники програми', 'Обговорення ринку, розбір угод, рекомендації'],
    resOverline: 'Що отримує учасник',
    resTitle: 'Девʼять конкретних результатів програми',
    results: ['Навчання з нуля', 'Живі заняття', 'Практика на ринку', 'Доступ до записів', 'Закритий чат', 'Індивідуальний зворотний звʼязок', 'Власна торгова система', 'Підтримка наставника', 'Підготовка до реальної торгівлі'],
    priceOverline: 'Формати участі',
    priceTitle: 'Оберіть інтенсивність супроводу',
    tiers: [
      {
        name: 'Груповий формат', price: '$2 599', size: 'До 20 учасників', start: 'Старт 18.01.2027', startDate: '2027-01-18T09:00:00-05:00',
        features: ['Повний 3-місячний курс', 'Усі живі заняття', 'Доступ до записів на час курсу', 'Закритий чат', 'Базовий зворотний звʼязок'],
        fit: 'Для тих, хто хоче отримати повноцінне навчання за максимально доступною вартістю.',
      },
      {
        name: 'Мала група', price: '$3 599', size: 'До 10 учасників', start: 'Старт 18.01.2027', startDate: '2027-01-18T09:00:00-05:00', badge: true,
        features: ['Усе з групового формату', 'У 2 рази більше уваги наставника', 'Щотижневий розбір ваших особистих угод', 'Персональний торговий план', 'Пріоритетні відповіді в чаті', 'Доступ до записів — ще 3 місяці після курсу'],
        fit: 'Для тих, хто хоче швидше вийти на стабільний результат завдяки персональній увазі.',
      },
      {
        name: 'Індивідуально', price: '$9 999', size: '1 на 1', start: 'Старт у будь-який час',
        features: ['6 місяців супроводу: 3 місяці навчання + 3 місяці підтримки', 'Персональна програма', 'Індивідуальні дзвінки', 'Повний розбір кожної угоди', 'Прямий контакт із наставником', 'Максимальний супровід'],
        fit: 'Для тих, кому потрібен максимальний результат за мінімальний час.',
      },
    ],
    aboutOverline: 'Про компанію',
    outOverline: 'Результати після навчання',
    outTitle: 'Наприкінці програми учень уміє:',
    outcomes: ['Самостійно аналізувати ринок', 'Визначати точки входу', 'Керувати ризиками', 'Працювати за власною системою', 'Контролювати емоції', 'Вести торговий журнал', 'Торгувати на реальному рахунку за чітким планом', 'Приймати рішення як професіонал'],
    ctaTitle: 'Розпочни свій шлях у трейдингу вже сьогодні',
    ctaSub: 'Запишись на консультацію й дізнайся, який формат навчання підійде саме тобі.',
    ctaBtn: 'Залишити заявку',
    ctaNote: 'Відповімо протягом робочого дня · 9:00–21:00 NY',
  },
  masterclass: {
    badge: 'Старт 23 вересня',
    urgency: 'Залишилося всього 3 місця!',
    heroLines: ['3-денний', 'майстер-клас', 'з трейдингу'],
    heroSub: '3 відеоуроки по 15–30 хвилин + практичні завдання. Підходить як новачкам, так і досвідченим трейдерам.',
    priceNow: '$59', priceOld: '$590', discount: 'Знижка 90%',
    ctaBtn: 'Записатися на майстер-клас',
    bonus: 'Бонус після реєстрації: як отримати капітал в управління до $1 млн!',
    aboutOverline: 'Інструктор',
    aboutTitle: 'Про майстер-клас та інструктора',
    aboutText1: 'Вітаю! Я професійний трейдер з багаторічним досвідом роботи на фінансових ринках. За свою карʼєру я допоміг сотням людей опанувати мистецтво трейдингу й почати заробляти на фінансових ринках.',
    aboutText2: 'Цей 3-денний майстер-клас — результат мого практичного досвіду. Тут лише перевірені стратегії та реальні техніки, які працюють як для новачків, так і для досвідчених трейдерів.',
    forOverline: 'Аудиторія',
    forTitle: 'Для кого цей майстер-клас',
    forCards: [
      { t: 'Для новачків', d: 'Ви навчитеся основ трейдингу з нуля, зрозумієте, як працюють ринки, і зробите перші кроки під керівництвом досвідченого наставника.' },
      { t: 'Для досвідчених трейдерів', d: 'Удоскональте навички, вивчіть просунуті стратегії управління ризиками та навчіться стабільно збільшувати прибуток.' },
      { t: 'Для тих, хто шукає дод. дохід', d: 'Трейдинг — можливість створити додаткове джерело доходу, приділяючи ринкам лише 1–2 години на день.' },
    ],
    getOverline: 'Зміст',
    getTitle: 'Що ви отримаєте',
    getItems: [
      { t: '3 відеоуроки', d: 'Щоденні 15–30-хвилинні уроки з практичними завданнями.' },
      { t: 'Дод. матеріали', d: 'Чек-листи, шаблони та корисні ресурси для навчання.' },
      { t: 'Підтримка', d: 'Доступ до Telegram-бота для отримання матеріалів і підтримки.' },
      { t: 'Спільнота', d: 'Закрита спільнота однодумців-трейдерів.' },
    ],
    progOverline: 'Програма',
    progTitle: 'Програма майстер-класу',
    days: [
      { num: '1', label: 'День 1', t: 'Старт і стратегії входу', d: 'Які ринки торгувати й чому. Інструменти та робочий простір. Зони попиту/пропозиції та тригери входу. Часті помилки новачків.' },
      { num: '2', label: 'День 2', t: 'Ризик-менеджмент і дисципліна', d: 'Розмір позиції. Стоп-лоси та тейки. Сценарне планування.' },
      { num: '3', label: 'День 3', t: 'Психологія трейдингу', d: 'Контроль емоцій і робота зі збитками. Дисципліна та торговий режим. Формування мислення професійного трейдера. Фінальний чек-лист і перехід до самостійної торгівлі.' },
    ],
    bonusOverline: 'Спеціальний бонус',
    bonusNote: 'для тих, хто пройде весь майстер-клас',
    bonusTitle: 'Як отримати капітал в управління до $1 млн',
    bonusText: 'Ексклюзивний гайд про те, як пройти відбір у проп-трейдингові компанії та отримати в управління капітал до 1 мільйона доларів для торгівлі.',
    achOverline: 'Підсумки',
    achTitle: 'Чого ви досягнете',
    achieves: [
      { t: 'Стабільність', d: 'Навчіться торгувати стабільно та впевнено.' },
      { t: 'Прибуток', d: 'Почнете генерувати регулярний дохід.' },
      { t: 'Навички', d: 'Опануєте професійні техніки.' },
      { t: 'Впевненість', d: 'Здобудете впевненість у своїх рішеннях.' },
    ],
    resOverline: 'Кейси',
    resTitle: 'Реальні результати',
    resText: 'Результати учнів після проходження майстер-класу та застосування системи на практиці.',
    cmpOverline: 'Порівняння',
    cmpTitle: 'Чому цей майстер-клас',
    usTitle: 'Цей майстер-клас',
    themTitle: 'Інші курси',
    us: ['Перевірені стратегії від практика', 'Лише актуальна інформація 2026', 'Реальні кейси та приклади', 'Практичні завдання щодня', 'Доступ до Telegram-спільноти', 'Бонус: шлях до капіталу $1 млн'],
    them: ['Застаріла теорія з підручників', 'Загальні фрази без конкретики', 'Немає практичних прикладів', 'Лише відео без завдань', 'Немає підтримки та спільноти', 'Завищена ціна за базову інформацію'],
    faqOverline: 'FAQ',
    faqTitle: 'Часті запитання',
    faqs: [
      { q: 'Я новачок, чи підійде мені цей майстер-клас?', a: 'Так. Програма побудована від бази до практики: ринки, інструменти, точки входу, ризик-менеджмент і психологія. Досвідчені трейдери закриють прогалини й систематизують свій підхід.' },
      { q: 'Чи потрібен великий стартовий капітал?', a: 'Ні. Почати можна з невеликої суми — головне система й дисципліна. А в бонусному гайді ми покажемо, як отримати в управління капітал до $1 млн.' },
      { q: 'Скільки часу потрібно приділяти трейдингу?', a: 'Під час майстер-класу — 15–30 хвилин на урок і 20–30 хвилин на завдання щодня. Надалі достатньо 1–2 годин на день.' },
      { q: 'Як я отримаю доступ до матеріалів?', a: 'Одразу після оплати: уроки та матеріали надходять через Telegram-бот, а посилання на закритий чат — у підтвердженні реєстрації.' },
      { q: 'Чи є гарантія повернення?', a: 'Так. Гарантія повернення коштів — 48 годин з моменту старту. Якщо зрозумієте, що формат не ваш, — повернемо оплату без запитань.' },
    ],
    finalTitle: 'Приєднуйтеся до майстер-класу просто зараз',
    timerTitle: 'До завершення акції залишилося:',
    timerUnits: { h: 'годин', m: 'хвилин', s: 'секунд' },
    ctaBtn2: 'Записатися зараз',
    ps: 'P.S. Ви нічим не ризикуєте! Гарантія повернення коштів — 48 годин з моменту старту.',
    stickyBtn: 'Приєднатися зі знижкою 90%',
  },
  account: {
    prompt: 'Увійдіть, щоб відкрити особистий кабінет',
    promptBtn: 'Увійти через Google',
    sub: 'Ви увійшли через Google-акаунт',
    logout: 'Вийти',
    since: 'На платформі з',
  },
  pay: {
    title: 'Оплата навчання',
    sub: 'Заявку отримано! Оберіть формат і завершіть оплату, щоб забронювати місце в потоці — старт 18 січня 2027.',
    chooseLabel: 'Оберіть формат',
    payBtn: 'Перейти до оплати',
    note: 'Безпечна оплата через Stripe · Після оплати ми звʼяжемося з вами в Telegram',
  },
  selPay: {
    title: 'Оплата відбору',
    sub: 'Заявку отримано! Оберіть формат участі та завершіть оплату — після цього команда звʼяжеться з вами в Telegram і відкриє доступ до міні-курсу та демо-етапу.',
    chooseLabel: 'Оберіть формат',
  },
  crypto: {
    title: 'Оплата в USDT',
    network: 'Мережа TRC20',
    walletLabel: 'Гаманець',
    copy: 'Копіювати',
    copied: 'Скопійовано',
    amount: 'Сума',
    hint: 'Перекажіть точну суму на гаманець нижче, потім натисніть кнопку — ми перевіримо надходження та відкриємо доступ.',
    paidBtn: 'Я надіслав оплату',
    modalTitle: 'Підтвердження оплати',
    modalSub: 'Вкажіть імʼя та Telegram — ми звіримо транзакцію та звʼяжемося з вами.',
    send: 'Надіслати',
    success: 'Сповіщення надіслано — ми перевіримо оплату та звʼяжемося з вами',
  },
  form: {
    title: 'Залишити заявку',
    name: 'Імʼя', namePh: 'Як до вас звертатися',
    telegram: 'Telegram', telegramPh: '@username',
    email: 'Email', emailPh: 'you@example.com',
    phone: 'Телефон', phonePh: '+380 00 000 00 00',
    experience: 'Досвід торгівлі',
    expOptions: ['Немає досвіду', 'До 1 року', '1–3 роки', 'Понад 3 роки'],
    message: 'Повідомлення (необовʼязково)', messagePh: 'Кілька слів про вашу мету',
    submit: 'Надіслати заявку', sending: 'Надсилаємо…',
    successTitle: 'Заявку надіслано',
    successText: 'Ми звʼяжемося з вами протягом робочого дня.',
    waitlistTitle: 'Заявка до листа очікування',
    waitlistSub: 'Малу групу розпродано. Залиште контакти — ми напишемо, щойно зʼявиться місце або відкриється новий потік.',
    waitlistSuccessTitle: 'Ви в листі очікування',
    waitlistSuccessText: 'Ми звʼяжемося з вами, щойно звільниться місце.',
    error: 'Не вдалося надіслати. Спробуйте ще раз.',
  },
  footer: {
    tagline: 'Професійна команда трейдерів. NYSE & NASDAQ.',
    links: 'Розділи',
    risk: 'Попередження про ризики: торгівля на біржі повʼязана з ризиком втрати капіталу. Минулі результати не гарантують майбутніх. Контент має освітній характер і не є інвестиційною рекомендацією.',
    rights: '© 2026 ALEF Traders. Усі права захищені.',
    tgBtn: 'Підтримка в Telegram',
    marketOpen: 'Ринок відкрито',
    marketClosed: 'Ринок закрито',
  },
  countdown: { label: 'До старту потоку', d: 'дн', h: 'год', m: 'хв', s: 'сек' },
  dcapital,
  payment: {
    checking: 'Перевіряємо оплату…',
    successTitle: 'Оплата пройшла успішно',
    successText: 'Доступ до майстер-класу та бонусного гайда «Як отримати капітал до $1 млн» надійде через Telegram-бот. Перевірте пошту та Telegram.',
    pendingText: 'Оплата обробляється — сторінка оновиться автоматично.',
    successTextTraining: 'Місце в потоці заброньовано. Команда звʼяжеться з вами в Telegram протягом робочого дня та додасть у закритий чат.',
    successTextSelection: 'Ви у відборі! Команда звʼяжеться з вами в Telegram протягом робочого дня і відкриє доступ до міні-курсу та демо-етапу.',
    backHome: 'На головну',
    cancelTitle: 'Оплату скасовано',
    cancelText: 'Нічого страшного — місце ще ваше. Завершити оплату можна будь-коли, доки діє знижка.',
    retry: 'Повернутися до майстер-класу',
    retryTraining: 'Повернутися до навчання',
    retrySelection: 'Повернутися до оплати відбору',
  },
};
